module.exports = __webpack_public_path__ + "static/media/city-cross-road-elements-svgrepo-com.5cbdec3d.svg";